/**
 * Scene palette — flat, bright, slightly desaturated pastels with a single
 * darker shade per material for depth. No gradients, no outlines: shapes read by
 * silhouette and colour, the way Toca Boca rooms do.
 *
 * The world half of it is deliberately low-contrast: tiles are a *background*,
 * and a floor that competes with the furniture standing on it makes a grid
 * harder to read, not easier.
 */

export const C = {
  // Grid floor: warm boards with just enough seam to count tiles by eye.
  floor: 0xf1cba4,
  floorAlt: 0xe9c19a,
  floorSeam: 0xd8ab7f,

  // Walls, drawn as blocks with a lit top edge and a shaded base.
  wall: 0xb9849e,
  wallTop: 0xd3a2ba,
  wallBase: 0x8f6479,
  wallShadow: 0x000000,

  // Dev mode's overlay: a grid, the tile under the cursor, the selected object.
  gridLine: 0xffffff,
  cursorOk: 0x63e6be,
  cursorBad: 0xff8fa3,
  selection: 0xffd166,
  spawnMark: 0x63e6be,

  // Furniture. The bed's linen is deliberately warm rather than white: a white
  // sheet under a white pillow is one flat shape from above.
  bedFrame: 0xcf8a4e,
  bedFrameDark: 0xa96c39,
  bedSheet: 0xf2e3d6,
  bedBlanket: 0x8fd3f4,
  bedBlanketFold: 0xb0e2f8,
  bedPillow: 0xfffdf9,
  bedPillowShade: 0xd9c7b6,

  wood: 0xe7a667,
  woodDark: 0xcf8a4e,
  woodLight: 0xf2c393,

  lampGlow: 0xffd166,
  lampShade: 0xffe9a8,
  lampBase: 0x7cc7a2,

  rug: 0xbfe3f2,
  rugInner: 0xe9f6fb,
  rugDot: 0xffb3d1,

  chest: 0xd98d5a,
  chestLid: 0xf0b183,
  chestIron: 0x8c6239,

  plant: 0x6fc98f,
  plantDark: 0x4fae72,
  pot: 0xe98d6b,

  // The cat itself — a tuxedo coat: soft black, never pure #000.
  catFur: 0x2f2c38,
  catFurShade: 0x24222b,
  catWhite: 0xfffdfa,
  catNose: 0xff9db6,
  catInnerEar: 0xffb3c6,
  catBlush: 0xffa8c2,
  eyeWhite: 0xfffdfa,
  eyeIris: 0x6fd3a8,
  eyePupil: 0x22212a,
  sparkle: 0xfff0a8,
  zzz: 0xffffff,
} as const;
